import { useParams } from 'react-router-dom';
import { AppDispatch, AppState } from '@nxsys/store';
import { useDispatch } from 'react-redux';
import { useEffect, useState } from 'react';
import { getStatutoryDetail } from '@nxsys/store/slices/statutory/action';
import GeneralInformation from '../components/GeneralInformation';
import AppCard from '@nxsys/components/AppCard';
import AppsContent from '@nxsys/components/AppsContainer/AppsContent';
import AppTableContainer from '@nxsys/components/AppTableContainer';
import { useSelector } from 'react-redux';
import { useTypedIntl } from '@nxsys/hooks/useTypedIntl';
import { getColumns } from './columns';
import DetailActionsModal from '../components/DetailActionsModal';
import {
  ACTIONS_STATUTORY_TYPE,
  STATUTORY_PAYMENT_TYPE,
} from '@nxsys/constants/statutory';
import AppsHeader from '@nxsys/components/AppsContainer/AppsHeader';
import { toNumber } from 'lodash';

const StatutoryDetail = () => {
  const { messages } = useTypedIntl();
  const { type, id } = useParams();
  const dispatch = useDispatch<AppDispatch>();
  const { statutoryDetail, loading } = useSelector(
    (state: AppState) => state.statutoryStore,
  );
  const [isEditing, setIsEditing] = useState(false);
  const [actionsModal, setActionsModal] = useState({
    open: false,
    title: messages['statutory.detail.stopStatutoryPayment'],
    type: ACTIONS_STATUTORY_TYPE.STOP,
    data: null,
  });

  const fetchData = () => {
    if (type && id) {
      dispatch(
        getStatutoryDetail({
          type: type as STATUTORY_PAYMENT_TYPE,
          id: toNumber(id),
        }),
      );
    }
  };

  useEffect(() => {
    fetchData();
  }, [type, id]);

  const toggleActionsModal = () =>
    setActionsModal({ ...actionsModal, open: !actionsModal.open });
  const handleOpenActionModal = (type: string, record: any) => {
    let title = '';
    if (type === ACTIONS_STATUTORY_TYPE.STOP) {
      title = messages['statutory.detail.stopStatutoryPayment'];
    }
    if (type === ACTIONS_STATUTORY_TYPE.RESUME) {
      title = messages['statutory.detail.resumeStatutoryPayment'];
    }
    if (type === ACTIONS_STATUTORY_TYPE.EDIT) {
      title = messages['statutory.detail.statutoryPayment'];
    }
    setActionsModal({
      ...actionsModal,
      open: true,
      title,
      type: type as ACTIONS_STATUTORY_TYPE,
      data: record,
    });
  };

  const toggleEditing = () => setIsEditing(!isEditing);

  return (
    <div className="flex flex-col gap-y-4">
      <GeneralInformation isEditing={isEditing} toggleEditing={toggleEditing} />
      <AppCard>
        <AppsHeader>
          <h5>{messages['statutory.detail.recordHistory']}</h5>
        </AppsHeader>
        <AppsContent>
          <AppTableContainer
            data={statutoryDetail?.records ?? []}
            loading={loading}
            page={0}
            total={statutoryDetail?.records?.length ?? 0}
            pageSize={statutoryDetail?.records?.length ?? 0}
            scroll={{ x: 1000, y: 700 }}
            titleEmpty={messages['statutory.detail.records.empty']}
            columns={getColumns({
              type: type as STATUTORY_PAYMENT_TYPE,
              statutoryDetail,
              isEditing,
              handleOpenActionModal,
              messages,
            })}
          />
        </AppsContent>
      </AppCard>
      <DetailActionsModal
        isOpen={actionsModal.open}
        toggle={toggleActionsModal}
        title={`${actionsModal.title} - ${type}`}
        actionType={actionsModal.type}
        refetchData={fetchData}
        data={actionsModal.data}
      />
    </div>
  );
};

export default StatutoryDetail;
